import { z } from 'zod/v4-mini';

import { PatientListMenuItems } from '@/pages/patients/patients-list/PatientListMenu.tsx';
import { Schema, cz } from '@/utils/zodUtils.ts';

export type PatientListUISettings = {
  selectedFilter?: PatientListMenuItems;
};

export const patientListUISettingsSchema: Schema<PatientListUISettings> =
  z.object({
    selectedFilter: cz.optional(z.literal(['monitored', 'gestational', 'all'])),
  });

export type BGMViewKind = 'downIsFuture' | 'downIsPast';

export type BGMPreferences = {
  viewKind?: BGMViewKind;
};

export const bgmPreferencesSchema: Schema<BGMPreferences> = z.object({
  viewKind: cz.optional(z.literal(['downIsFuture', 'downIsPast'])),
});
